<script lang="ts">
    export let mode = "plain_text"
    export let text = ""

    import { onMount } from 'svelte'
    import { ace_modes } from '../stores/ace_modes_store'

    import { AceEditor } from "svelte-ace"

    import "brace/mode/c_cpp"
    import "brace/mode/css"
    import "brace/mode/dockerfile"
    import "brace/mode/haskell"
    import "brace/mode/html"
    import "brace/mode/markdown"
    import "brace/mode/javascript"
    import "brace/mode/json"
    import "brace/mode/julia"
    import "brace/mode/plain_text"
    import "brace/mode/python"
    import "brace/mode/rust"
    import "brace/mode/sh"
    import "brace/mode/sql"
    import "brace/mode/tex"

    import "brace/theme/tomorrow_night_bright"

    let editor = null

    onMount(() => {
        $ace_modes = [
            'c_cpp',
            'css',
            'dockerfile',
            'haskell',
            'html',
            'javascript',
            'markdown',
            'json',
            'julia',
            'plain_text',
            'python',
            'rust',
            'sh',
            'sql',
            'tex',
        ]
    })
</script>

<AceEditor
        on:input
        autofocus
        width='100%'
        height='100%'
        bind:lang={mode}
        theme="tomorrow_night_bright"
        bind:value={text} />
